import React from 'react';
import { MessageSquare, Truck, HardHat } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function AnnouncementBar() {
  const location = useLocation();
  const isContractors = location.pathname.includes('subcontractors') || location.pathname.includes('contractors');
  const bgColor = 'bg-[#5b5858]';
  const borderColor = 'border-[#535050]';
  return <div className={`${`${bgColor} text-white py-2 px-4 text-xs sm:text-sm font-medium relative z-[60] transition-colors duration-300 border-b ${borderColor}`} bg-[#4A5130]`} data-id="element-130">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 sm:gap-4" data-id="element-131">
        <div className="flex items-center" data-id="element-132">
          <Truck className="w-4 h-4 mr-1.5 hidden sm:block" data-id="element-133" />
          <span className="hidden sm:inline" data-id="element-134">
            Bulk Delivery Across King County
          </span>
          <span className="sm:hidden" data-id="element-135">Bulk Delivery Available</span>
        </div>
        <span className="opacity-50" data-id="element-136">|</span>
        <a href="tel:206-619-3742" className="flex items-center hover:text-white/80 transition-colors font-[500]" data-id="element-137">
          (206) 619-3742
        </a>
        <span className="opacity-50" data-id="element-138">|</span>
        <Link to="/subcontractors" className={`${`flex items-center transition-colors font-bold ${isContractors ? 'text-[#14b88a] hover:text-[#4ce0b6]' : 'text-white hover:text-white/80'}`} font-[600]`} data-id="element-139">
          <HardHat className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1" data-id="element-140" />
          Contractors
        </Link>
      </div>
    </div>;
}